export const METHOD_OPTIONS = [
    { key: 'email', value: 'Email', text: 'Email' },
    { key: 'post', value: 'Post', text: 'Post' },
];
